module.exports = __webpack_public_path__ + "img/section4Content3.97d3e48c.png";